module.exports = function () { return {}; };